import React from "react"
import { StaticQuery, graphql } from "gatsby"

export default (OriginalReactComponent) => {
  return class extends React.Component {
    render() {
      //return original react component with additional props
      return (
        <StaticQuery
          query={graphql`
            query {
              storyblokEntry(slug: { eq: "events-config" }) {
                content
              }
            }
          `}
          render={(data) => {
            const eventsConfig = JSON.parse(data.storyblokEntry.content)
            return (
              <OriginalReactComponent
                eventsConfig={eventsConfig}
                {...this.props}
              />
            )
          }}
        />
      )
    }
  }
}
